import construct from "./methods/construct.js";

export default {
    observedElements: {},
    construct,
};
